import _ from "lodash";
import {
  Component,
} from "react";
import store from "CommonState/store";
import {
  schema,
} from "Apis/person-lbvperson-api";
import {
  createInjectsSelector,
  injectsFromSchema,
} from "CommonCore/schema-util";
import SHKFormTab, {
  buildSubSchemas,
} from "App/shk-form-tab";
import {
  ASTMODUSKEY,
} from "App/constants";
import {
  getModus,
} from "App/antragsteller-modus";

export const subpanels = [
  { key: "kinder", header: "Angaben zu Kindern", endpoint: `/api/shkperson/lbvperson` },
  { key: "steuer", header: "Steuermerkmale", endpoint: `/api/shkperson/lbvperson` },
  { key: "lbv", header: "LBV Bezüge", endpoint: `/api/shkperson/lbvperson` },
];

buildSubSchemas(subpanels, schema);

const injects = _.flatMap(subpanels, s => injectsFromSchema(s.schema));
const selectInjects = createInjectsSelector(injects);

_.map(subpanels, panel => _.assign(panel, { route: "/person/steuer", label: "LBV 1: Persönliche Angaben" }));

@store(...injects, "user", "flag_antragstellermodus")
export default class PersonLBVPersonTab extends Component {
  constructor() {
    super();
  }
  componentDidMount() {
    getModus(this.props);
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.flag_antragstellermodus !== this.props.flag_antragstellermodus) {
      await getModus(this.props);
    }
  }

  render() {
    let panels = _.clone(subpanels);
    if (this.props.flag_antragstellermodus == ASTMODUSKEY.Hilfskraft) {
        // Bei Hilfskräften Kinder-Panel weglassen
      panels = panels.filter(x => x.key != "kinder");
    }

    return <SHKFormTab subpanels={panels} injects={selectInjects(this.props)} />;
  }
}
